import {
  ScheduleConstraintCode,
  type ScheduleConstraint,
  type ScheduleConstraintMode,
} from 'services/api/schedule-configuration';

export const ALL_CONSTRAINT_CODES = Object.values(
  ScheduleConstraintCode,
) as ScheduleConstraintCode[];

export const getDefaultConstraints = (
  providedConstraints: ScheduleConstraint[],
): ScheduleConstraint[] =>
  providedConstraints.map((constraint) => ({
    code: constraint.code,
    mode: 'DISABLED' as ScheduleConstraintMode,
  }));

export const isConstraintChecked = (
  constraints: ScheduleConstraint[],
  code: ScheduleConstraintCode,
): boolean => constraints.find((c) => c.code === code)?.mode === 'ENABLED';

export const setConstraintMode = (
  constraints: ScheduleConstraint[],
  code: ScheduleConstraintCode,
  mode: ScheduleConstraintMode,
  providedConstraints: ScheduleConstraint[],
): ScheduleConstraint[] => {
  const hasCode = constraints.some((c) => c.code === code);
  const base = hasCode
    ? constraints.map((c) => (c.code === code ? { ...c, mode } : c))
    : [...constraints, { code, mode }];
  return providedConstraints.map((c) => ({
    code: c.code,
    mode: base.find((x) => x.code === c.code)?.mode ?? ('DISABLED' as ScheduleConstraintMode),
  }));
};

export const setAllConstraintsMode = (
  mode: ScheduleConstraintMode,
  providedConstraints: ScheduleConstraint[],
): ScheduleConstraint[] =>
  providedConstraints.map((providedConstraint) => ({
    ...providedConstraint,
    mode,
  }));

export const areAllConstraintsChecked = (
  constraints: ScheduleConstraint[],
  providedConstraints: ScheduleConstraint[],
): boolean =>
  constraints.length === providedConstraints.length &&
  constraints.every((c) => c.mode === 'ENABLED');

export const getCheckedConstraintsCount = (constraints: ScheduleConstraint[]): number =>
  constraints.filter((c) => c.mode === 'ENABLED').length;
